import { appConfig } from "./app.config";

export const appAsset = {
  logo: `${appConfig.assetPath}/icon-512x512.png?${new Date().toISOString()}`,
  bukoLogo: "/buko-logo.png",
  page404: "/404.png",
  loginBg: `${appConfig.assetPath}/login-bg-1.jpg?${new Date().toISOString()}`,
  loginBg2: `${appConfig.assetPath}/login-bg-2.jpg?${new Date().toISOString()}`,
  previewLogo: `/preview-file-logo.png?${new Date().toISOString()}`,
  previewFooter: `/preview-file-footer.png?${new Date().toISOString()}`,
};
